import React, { useEffect, useState } from "react";
import { useTabs } from "../hooks/useTabs";
import Input from "../ui/Input";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Label from "../ui/Label";
import Space from "../ui/Space";
import Divider from "../ui/Divider";
import { getSaved, save } from "../utils/Utils";
import { showError, showMessage } from "../ui/Message";
import Spin from "../ui/Spin";
import { pubCall } from "../utils/PubSub";
import { InfoIcon } from "../utils/Icons";
import Status from "../ui/Status";

export default function CustomersSearch(props) {

    const { controller = "", route, state = {}, setState = () => { }, callback = () => { } } = props;

    const [loading, setLoading] = useState(false);


    const defaultTabs = [
        { help: "Keyword, phone, email, or account; separate with ;", label: "Keyword", key: "keywords", v6lue: "" },
        { help: "Name as entered (or start of)", label: "Name", key: "name", value: "" },
        { help: "Find related customers; separate terms with ;", label: "Related", key: "related", value: "" },
        { help: "Account (shipto) number", label: "Account", key: "account", value: "" },
        { help: "Billto account", label: "Bill to", key: "bill_to", value: "" },
        { help: "Online Account: online account or SAN", label: "Online Account", key: "olact", value: "" },
        { help: "Leave blank for recent adds, or enter record number", label: "Recent", key: "recent", value: "" },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(getSaved("customer_search") || defaultTabs, "keywords");


    const search = () => {
        setLoading(true);
        const val = getVal(index);
        save("customer_search", tabs);


        switch (index) {
            case "keywords":
                pubCall("customer.searchKeyword", { search_term: val, limit: 40 }, (_s, _r) => {
                    setLoading(false);
                    if (_s) {
                        setState({ ...state, "search": "Searching Keywords: " + val + " (" + _r.rows.length + ") results" })
                        callback({ results: _r, dynamic: false })
                    } else { showError(_r) }
                })
                return;
            case "name":
                pubCall("customer.searchName", { name: val, limit: 40 }, (_s, _r) => {
                    setLoading(false);
                    if (_s) {
                        setState({ ...state, "search": "Searching Name: " + val })
                        callback({ results: _r, dynamic: true })
                    } else { showError(_r) }
                })
                return;
            case "bill_to":
                pubCall("customer.searchBillTo", { bill_to: val, limit: 40 }, (_s, _r) => {
                    setLoading(false);
                    if (_s) {
                        setState({ ...state, "search": "Searching Billto: " + val })
                        callback({ results: _r, dynamic: true })
                    } else { showError(_r) }
                })
                return;
            case "account":
                pubCall("customer.searchShipTo", { ship_to: val, limit: 40 }, (_s, _r) => {
                    setLoading(false);
                    if (_s) {
                        callback({ results: _r, dynamic: true })
                    } else { showError(_r) }
                })
                return;
            case "olact":
                pubCall("customer.searchSan", { san: val, limit: 40 }, (_s, _r) => {
                    setState({ ...state, "search": "Searching Shipto: " + val })
                    setLoading(false);
                    if (_s) {
                        callback({ results: _r, dynamic: true })
                    } else { showError(_r) }
                })
                return;

            default:
                showError({ error: "Not implemented" });
                setLoading(false);
                break;
        }

    }

    useEffect(() => {
        const el = refs?.current?.[index];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
        const actions = [
            { key: KBD.TAB, action: next },
            { key: KBD.SHIFT_TAB, action: prev },
            { key: KBD.ARROW_DOWN, action: next },
            { key: KBD.ARROW_UP, action: prev },
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },
            { key: KBD.ENTER, action: search },
            { key: KBD.PAGE_DOWN, action: search },
        ];
        const cleanup = listen(controller, ROUTES.CUSTOMER.SEARCH, actions, false, [KBD.ENTER, KBD.ESCAPE, KBD.TAB, KBD.SHIFT_ENTER, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.PAGE_DOWN]);
        return cleanup;
    }, [index, tabs]);


    const help = defaultTabs.find(item => item.key === index);
    return (
        <Spin loading={loading} style={{ "padding": "15px" }}>
            <div style={{ "width": "410px" }}>
                <div style={{"width" : "300px", "margin" : "0 auto"}}>
                    <div className="shim" /><div className="shim" />
                    <Space size={10}>
                        <Label width={70}>Keywords</Label>
                        <Divider vertical />
                        <Input maxLength={50} {...editProps("keywords")} className={(index !== "keywords") ? "dim" : ""} />
                    </Space>
                    <div className="shim" />
                    <Space size={10}>
                        <Label width={70}>Name</Label>
                        <Divider vertical />
                        <Input maxLength={50} {...editProps("name")} className={(index !== "name") ? "dim" : ""} />
                    </Space>
                    <div className="shim" />
                    <Space size={10}>
                        <Label width={70}>Related</Label>
                        <Divider vertical />
                        <Input maxLength={50} {...editProps("related")} className={(index !== "related") ? "dim" : ""} />
                    </Space>
                    <div className="shim" />
                    <Space size={10}>
                        <Label width={70}>Account</Label>
                        <Divider vertical />
                        <Input maxLength={10} {...editProps("account")} className={(index !== "account") ? "dim" : ""} />
                    </Space>
                    <div className="shim" />
                    <Space size={10}>
                        <Label width={70}>Billto</Label>
                        <Divider vertical />
                        <Input maxLength={10} {...editProps("bill_to")} className={(index !== "bill_to") ? "dim" : ""} />
                    </Space>
                    <div className="shim" />
                    <Space size={10}>
                        <Label width={70}>OLact</Label>
                        <Divider vertical />
                        <Input maxLength={10} {...editProps("olact")} className={(index !== "olact") ? "dim" : ""} />
                    </Space>
                    <div className="shim" />
                    <Space size={10}>
                        <Label width={70}>Recent</Label>
                        <Divider vertical />
                        <Input maxLength={50} {...editProps("recent")} className={(index !== "recent") ? "dim" : ""} />
                    </Space>
                    <div className="shim" /><div className="shim" />
                </div>
            </div>
            <Status><InfoIcon /> {help?.help}</Status>
        </Spin>
    )
}